import React from 'react';
import { Redirect } from 'react-router-dom';

import { TenantRole } from 'api/endpoints/tenants';
import Spinner from 'components/atoms/spinner';
import { USER_ROLE, UserRole } from 'constants/roles';
import { useUserInfo } from 'hooks/useUserInfo';

const accessibleByRole =
  (redirectPath: string) =>
  (roles: Array<UserRole | TenantRole>) =>
  (Component: React.ComponentType) =>
  () => {
    const { tenantRole, isCurrentUserInfoLoading } = useUserInfo();

    const isAllow: boolean =
      !!tenantRole &&
      (roles.includes(tenantRole) || tenantRole === USER_ROLE.ADMIN);

    if (isCurrentUserInfoLoading) {
      return <Spinner />;
    }

    if (isAllow) {
      return <Component />;
    }

    return <Redirect to={redirectPath} />;
  };

export default accessibleByRole;
